var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"main_head"},[_c('IconBase',{attrs:{"width":_vm.iconW,"height":_vm.iconH,"icon-name":_vm.iconName}},[_vm._t("default")],2),_c('span',[_vm._v(_vm._s(_vm.title))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }